<form class="form-popup" [formGroup]="formGroup">

  <h4>{{ itemToAdd.description }}</h4>

  <mat-form-field appearance="fill">
    <mat-label>Quantity To Add</mat-label>
      <input matInput onfocus="this.select()"
          type="number" name="Quantity To Add"
          class="fullWidth"
          formControlName="addedQuantity"
      />
    </mat-form-field>

</form>
